import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { METRIC_OPTIONS } from './metricOptions';
import { t } from '@/i18n';

export const AddWidgetDialog = ({ open, onOpenChange, nodes, onAdd }) => {
  const [selectedNodeId, setSelectedNodeId] = useState('');
  const [selectedMetric, setSelectedMetric] = useState('');

  const handleAdd = () => {
    if (selectedNodeId && selectedMetric) {
      onAdd({ nodeId: selectedNodeId, metric: selectedMetric });
      setSelectedNodeId('');
      setSelectedMetric('');
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[380px]">
        <DialogHeader>
          <DialogTitle>{t('widget.addTitle')}</DialogTitle>
          <DialogDescription>{t('widget.addDescription')}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div>
            <label className="text-sm font-medium mb-1.5 block">{t('widget.sourceNode')}</label>
            <Select value={selectedNodeId} onValueChange={setSelectedNodeId}>
              <SelectTrigger><SelectValue placeholder={t('widget.selectNode')} /></SelectTrigger>
              <SelectContent>
                {nodes.map(n => (
                  <SelectItem key={n.id} value={n.id}>{t(`supplyChain.node.${n.type}`)}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <label className="text-sm font-medium mb-1.5 block">{t('widget.metric')}</label>
            <Select value={selectedMetric} onValueChange={setSelectedMetric}>
              <SelectTrigger><SelectValue placeholder={t('widget.selectMetric')} /></SelectTrigger>
              <SelectContent>
                {METRIC_OPTIONS.map(m => (
                  <SelectItem key={m.key} value={m.key}>{t(m.labelKey)}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>{t('widget.cancel')}</Button>
          <Button onClick={handleAdd} disabled={!selectedNodeId || !selectedMetric}>{t('widget.add')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
